import primaryComponents from "../../../../primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";
import { EyeIcon, PlusIcon, UserIcon } from "../../../../../assets/svgIcons";
import { useGetAudiences } from "../../../../../hooks/api/queries/useMarketing";
import secondaryComponents from "../../..";
import { useState } from "react";
import { RoutedModal } from "../../../../common";
import { AudienceForm } from "../AudienceForm";
import { TotalRecipients } from "../../TotalRecipients";
import ToolTipV2 from "../../../ToolTipV2";

export const SegmentedList = ({
  formData,
  setFormData = () => {},
  smsCampaign = {},
}) => {
  const [isRecipient, setisRecipient] = useState(null);
  const [queryParams, setQueryParams] = useState({ query: "", per_page: 50 });
  const [isAudienceView, setIsAudienceView] = useState(false);
  const { data, isLoading } = useGetAudiences({ queryParams });
  const audiences = data?.data;

  return (
    <>
      <div
        className={` ${globalStyles["cardWithBackground"]} white`}
        style={{ gap: "15px" }}
      >
        <div className="d-flex" style={{ gap: "10px" }}>
          <primaryComponents.SearchField
            classNames="w-100"
            placeholder="Search segments"
            trigger={(val) => {
              setQueryParams((prev) => ({ ...prev, query: val }));
            }}
          />{" "}
          <primaryComponents.Button
            classNames={"btn btn--outline"}
            onClick={() => setIsAudienceView(true)}
          >
            <PlusIcon className="mr-1" />
            New
          </primaryComponents.Button>
        </div>

        <div className={`${styles.segment} p-0`}>
          <span
            className="ml-auto cursor-pointer"
            onClick={() =>
              setFormData((prev) => ({
                ...prev,
                audience_id: "",
                no_of_audience: 0,
              }))
            }
          >
            Clear
          </span>
          <secondaryComponents.LoaderHelper
            isLoading={isLoading}
            classNames={"mt-5"}
          >
            {audiences?.map((audience) => (
              <div className={styles.segment__card} key={audience?.id}>
                <label
                  htmlFor={`${audience?.id}`}
                  className="d-flex cursor-pointer"
                  style={{ gap: "10px" }}
                >
                  <primaryComponents.RadioButton
                    name="smsAudience"
                    id={`${audience?.id}`}
                    isControlled={true}
                    checked={formData?.audience_id === audience?.id}
                    setRadioValue={() => {
                      setFormData((prev) => ({
                        ...prev,
                        audience_id: audience?.id,
                        no_of_audience: audience?.customer_count,
                      }));
                    }}
                  />
                  <div>
                    <h6>{audience?.title}</h6>
                    <p className="small-text-size">
                      {audience?.description || "N/A"}
                    </p>
                  </div>
                </label>

                <div>
                  <span
                    className={`${globalStyles["statusBlock--purple"]} d-flex align-items-center justify-content-center gray--text`}
                    style={{ minWidth: "auto" }}
                  >
                    <UserIcon className="mr-1" style={{ fontSize: "15px" }} />
                    {audience?.customer_count || 0}

                    <ToolTipV2 tipText="View Recipients">
                      <span
                        className="ml-3 cursor-pointer"
                        onClick={() => setisRecipient(audience?.id)}
                      >
                        <EyeIcon stroke="#7647ee" size={20} />
                      </span>
                    </ToolTipV2>
                  </span>
                </div>
              </div>
            ))}
          </secondaryComponents.LoaderHelper>
        </div>
      </div>

      <RoutedModal
        headerTitle="Create Audience Group"
        isActive={isAudienceView}
        width={550}
        closeModal={() => setIsAudienceView(false)}
        style={{ height: "auto" }}
      >
        <AudienceForm closeModal={() => setIsAudienceView(false)} />
      </RoutedModal>

      <RoutedModal
        isActive={!!isRecipient}
        width={"700px"}
        headerTitle="Recipients"
        closeModal={() => setisRecipient(null)}
      >
        <TotalRecipients
          smsCampaign={{ ...smsCampaign, audience: { id: isRecipient } }}
          isAudience={true}
        />
      </RoutedModal>
    </>
  );
};
